define(function () {
	var IpsModelCollection = require('civicsBase/ipsModelCollection');
	const mapUtils = require('civicsUtils/map_utilities');

	const address = 'address';
	const parcel = 'parcel';
	const asset = 'asset';
	const property = 'property';


	//note that this collection serves as a base for the other extent queries. You can't use this as is.
	return IpsModelCollection.extend({
		//urlRoot: '/delegate/civics-api/api/property/addresses?MapExtent={Min:{X:{0},Y:{1}},Max:{X:{2},Y:{3}}}&page=[{Start:1,Max:0}]&IsEffective=true&IsExpired=false',
		//{Min:{X:-115.22582910386741,Y:36.175155876935506},Max:{X:-115.2250712693324,Y:36.17546174454457}}
		url: function () {
			var url = null;
			if (this.coordinates || this.extent) {
				var extent = this.extent ? this.extent : mapUtils.buildExtentFromPoint(this.coordinates.x, this.coordinates.y, this.extentSize);
				url = this.urlRoot.format(extent.min.x, extent.min.y, extent.max.x, extent.max.y);
			}
			return url;
		},
		parse: function (response) {
			let data = response.data;
			if (data && data.length > 1 && this.skipSort!==true) {
				let filteredSites = data.filter((item) => { return item.Spatial != undefined });
				var closest = mapUtils.sortSitesByDistance(this.coordinates ? this.coordinates : this.point, filteredSites);
				data = closest;
			}
			if (data && data.length > 1 && this.returnClosestSite === true) {
				data = [data[0]];
			}
			data.forEach(site => {
				//this.siteType is declared in the address/parcel/asset child classes.
				site._siteType = this.siteType;
				site._displayText = this.siteType == parcel ? site.parcelId : site.displayText;
			});
			return data;
		},
		idPrefixes:{//we might need to add prefixes if we encounter ID overlap. otherwise we can alter the selected sites / location picker collections to use _siteType and ID as the model ID.
			address:'a',
			parcel:'p',
			property:'?_?_',
			asset:'c'
		}
		//end backbone functions//
	});
});
